import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy'
})
export class LedgerTransactionCardsSummaryPipe implements PipeTransform {

  transform(value: any[], field: string, order: string[]): any[] {
    if (!value || !field || !order) {
      return value;
    }

    return value.sort((a, b) => {
      const aIndex = order.indexOf(a[field]);
      const bIndex = order.indexOf(b[field]);

      if (aIndex < bIndex) {
        return -1;
      } else if (aIndex > bIndex) {
        return 1;
      } else {
        return 0;
      }
    });
  }
}